<div class="box card-box side-panel light">
  <div class="box-header flex flex-between align-items-center">
    <h3 class="text-ellipsis text-accent">{{ 'TEMPLATE.insert_signature' | translate }}</h3>
    <button (click)="close()"
            class="btn btn-outline pull-right"
            test-id="btnCloseSignaturePanel"
            type="button">
      <span class="fa fa-light fa-times"></span>
    </button>
  </div>
  <div class="box-body">
    <section class="signature-panel-section">
      <h4 class="signature-section-title">1. {{ 'TEMPLATE.add_signer_roles' | translate }}</h4>
      <p class="text-sm text-muted">{{ 'TEMPLATE.add_signer_roles_help' | translate }}</p>
      <div class="signer-role-add">
        <input #signerRoleInput
               [formControl]="signerRoleControl"
               (keydown.enter)="addSignerRole()"
               class="form-control"
               id="signerRole"
               [attr.maxlength]="maxSignatureRoleLength"
               placeholder="{{ 'TEMPLATE.signer_role_examples' | translate }}"
               test-id="signerRoleInput"
               type="text"/>
        <button (click)="addSignerRole()"
                [disabled]="!canAddSignerRole"
                class="btn btn-primary btn-sm"
                test-id="btnAddSignature"
                type="button">
          <em aria-hidden="true" class="fa fa-light fa-plus m-r-xs"></em>
          {{ 'TEMPLATE.add_signer_role' | translate }}
        </button>
      </div>
    </section>

    <section class="signature-panel-section">
      <div class="signature-section-heading">
        <h4 class="signature-section-title mb-0">
          2. {{ 'TEMPLATE.signer_roles' | translate }}
          <span *ngIf="signatureRoleEntries.length">({{ signatureRoleEntries.length }}/{{ maxSignatureRoles }})</span>
        </h4>
        <label class="checkbox text-sm mb-0 signing-order-toggle"
               [class.text-muted]="!canConfigureSigningOrder">
          <input type="checkbox"
                 test-id="signatureOrderToggle"
                 [checked]="signatureOrderMode === 'ORDERED'"
                 [disabled]="!canConfigureSigningOrder"
                 (change)="changeSignatureOrder($event)">
          {{ 'DOCUMENTS.sequential_signing' | translate }}
          <em class="fa fa-light fa-info-circle" [style.padding-left.px]="4"
              [title]="'DOCUMENTS.sequential_signing_help' | translate"></em>
        </label>
      </div>

      <div *ngIf="!signatureRoleEntries.length" class="signature-role-empty-state">
        <strong>{{ 'TEMPLATE.no_signer_roles' | translate }}</strong>
        <span class="text-sm text-muted">{{ 'TEMPLATE.no_signer_roles_help' | translate }}</span>
      </div>

      <ul *ngIf="signatureRoleEntries.length" class="signature-role-list">
        <li
          *ngFor="let entry of signatureRoleEntries; let i = index; trackBy: trackBySignerRole"
          (dragover)="allowSignerRoleDrop($event)"
          (drop)="dropSignerRole(i, $event)"
          class="signature-role-item"
          [class.signature-role-item--dragging]="draggedSignerRoleIndex === i"
          [class.signature-role-item--delete-confirmation]="pendingDeletionRole === entry.role"
          [ngClass]="'signature-role-item--color-' + entry.signatureIndex"
          test-id="signatureRoleItem">
          <ng-container *ngIf="pendingDeletionRole !== entry.role; else deleteConfirmation">
          <button *ngIf="signatureOrderMode === 'ORDERED'"
                  (dragend)="stopDraggingSignerRole()"
                  (dragstart)="startDraggingSignerRole(i, $event)"
                  [attr.aria-label]="'TEMPLATE.reorder_signer_role' | translate"
                  class="btn btn-sm btn-icon white signature-role-drag-handle"
                  draggable="true"
                  test-id="dragSignerRole"
                  type="button">
            <em aria-hidden="true" class="fa fa-solid fa-grip-vertical"></em>
          </button>
          <ng-container *ngIf="{count: signatureCountFor(entry)} as signature">
            <div class="signature-role-summary">
              <span class="text-ellipsis signature-role-name"
                    [title]="entry.role">
                <ng-container *ngIf="signatureOrderMode === 'ORDERED'">{{ i + 1 }}. </ng-container>{{ entry.role }}
              </span>
              <span class="signature-role-count">
                {{ signature.count }}
                {{ (signature.count === 1 ? 'TEMPLATE.signature_field' : 'TEMPLATE.signature_fields') | translate }}
              </span>
            </div>
                <button (click)="$event.stopPropagation(); addSignatureForRole(entry)"
                    class="btn btn-sm btn-outline b-primary text-primary signature-role-action"
                    test-id="action-add-signature"
                    type="button">
              <em aria-hidden="true" class="fa fa-light fa-signature m-r-xs"></em>
              {{ (signature.count > 0 ? 'TEMPLATE.place_another_signature' : 'TEMPLATE.add_signature') | translate }}
            </button>
          </ng-container>
            <button (click)="requestDeleteSignerRole(entry)"
                  class="btn btn-sm btn-icon white signature-role-action text-danger"
                  [title]="'COMMON.delete' | translate"
                  test-id="action-delete-signer-role"
                  type="button">
            <em aria-hidden="true" class="fa fa-light fa-trash"></em>
          </button>
          </ng-container>
          <ng-template #deleteConfirmation>
            <div class="signature-role-delete-message">
              <em aria-hidden="true" class="fa fa-light fa-triangle-exclamation text-danger"></em>
              <span>
                {{ 'TEMPLATE.confirm_delete_signer_role_inline' | translate : {signerRole: entry.role} }}
              </span>
            </div>
            <div class="signature-role-delete-actions">
              <button (click)="cancelDeleteSignerRole()"
                      class="btn btn-sm btn-outline"
                      test-id="action-cancel-delete-signer-role"
                      type="button">
                {{ 'FORMS.cancel' | translate }}
              </button>
              <button (click)="deleteSignerRole(entry)"
                      class="btn btn-sm btn-danger"
                      test-id="action-confirm-delete-signer-role"
                      type="button">
                {{ 'COMMON.delete' | translate }}
              </button>
            </div>
          </ng-template>
        </li>
      </ul>
      <p *ngIf="signatureRoleEntries.length" class="signer-role-help text-sm text-muted">
        <em aria-hidden="true" class="fa fa-light fa-info-circle text-info"></em>
        <span>{{ 'TEMPLATE.signer_role_help' | translate }}</span>
      </p>
    </section>

    <section class="signature-panel-section signature-method-section">
      <h4 class="signature-section-title">3. {{ 'TEMPLATE.allowed_signature_methods' | translate }}</h4>
      <p class="text-sm text-muted">{{ 'TEMPLATE.allowed_signature_methods_help' | translate }}</p>
      <gp-signature-method-select [options]="signatureMethodOptions"
                                  [selected]="selectedSignatureMethods"
                                  [compact]="true"
                                  [multiple]="true"
                                  [disabled]="!signatureRoleEntries.length"
                                  (selectedChange)="selectSignatureMethod($event)">
      </gp-signature-method-select>
    </section>
  </div>
</div>
